exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-text-field--outlined > .v-input__control > .v-input__slot {\n  background-color: white !important;\n}\n.mb-2 {\n  padding-bottom: 8px;\n}\n.ml-2 {\n  padding-left: 8px;\n}\n.mr-2 {\n  padding-right: 8px;\n}\n.mx-2 {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n", ""]);

// exports
